import styled from "styled-components";
export const Container = styled.div``;

export const StyledInput = styled.input`
  font-size: 15px;
  margin: 10px 0 20px 0;
  width: 300px;
  border: none;
  border-bottom: 1px solid var(--secondary-color);
  background-color: transparent;
  padding: 0 0 10px 10px;
`;
